<template>
  <div>
    <v-container>
      <v-data-table 
        :headers="headers" 
        :items="recentJobReports" 
        :loading="loading"
        hide-default-footer>
        <template #:body="{items}">
          <tbody v-if="items.length > 0">
            <tr v-for="(item, index) in items" :key="`${item.ReportID}-${index}`">
              <td>{{`${item.JobReference}`}}</td>
              <td>{{`${item.Location}`}}</td>
              <td>{{`${item.JobStatus}`}}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td :colspan="headers.length" style="text-align: center">No Jobs</td>
            </tr>
          </tbody>
        </template>
        <template #[`item.StartDate`]="{item}">
          <td>{{`${$dateHelper.GetDateAsDMYString(item.StartDate)}`}}</td>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as ReportAPI from '@/api/reportAPI';
import Report from '../../../../shared/models/report';

@Component({})
export default class RecentJobReportsList extends Vue {
  @Prop(String) public locationID!: string | null;
  @Prop(String) public clientID!: string | null;

  private get headers() {
    return [
      {
        text: 'Job Ref.',
        value: 'JobReference',
        sortable: false,
      },
      {
        text: 'Location',
        value: 'Location',
        sortable: false,
      },
      {
        text: 'Report Type',
        value: 'ReportType',
        sortable: false,
      },
      {
        text: 'Publish Date',
        value: 'PublishDate',
        sortable: false,
      },
    ];
  }

  private loading = true;
  private loadError = "";
  private recentJobReports: Report[] = [];

  @Watch('locationID', { immediate: true, deep: true })
    onItemChanged() {
      this.load();
    }

  @Watch('clientID', { immediate: true, deep: true })
  onClientIDLoaded() {
    if (this.clientID != "")
      this.load();
  }

  private async load() {
    this.loadError = "";

    try {
      this.recentJobReports = await ReportAPI.getTenRecentReports(this.clientID, this.locationID);
    } catch (ex) {
      this.$emit("onLoad", ex);
    } finally {
      this.loading = false;
    }
  }
}
</script>

<style>
</style>